import React, { ChangeEvent, useEffect, useState } from "react";
import { Button, Card, CardBody, Container } from "react-bootstrap";
import { useAuth } from "../../../contexts/AuthContext";
import { IQuerySelectData, IItemBaseVariant, IQuery, CastType, IQueryExtract, IItemBase } from "../../../component/solution/Interfaces";
import { ArrowLeft, Download, FileText, ImageOff, Search, Upload, UploadCloud, X,  ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Pencil, ArrowDown  } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import ShowErrorAlert from "../../../component/ShowErrorAlert";
import { DndContext, closestCenter, useSensor, useSensors, PointerSensor } from "@dnd-kit/core";
import { SortableContext, arrayMove, useSortable, rectSortingStrategy, horizontalListSortingStrategy} from "@dnd-kit/sortable";
// import { SortableBaseProductImages } from "../../../component/draggable/SortableBaseProductImages";
import { SortableProductVariantImages } from "../../../component/draggable/SortableProductVariantImages";


export const ProductsVarieties: React.FC = () => {


    const { fetchData, responseErrorMessage, showErrorAlert }  = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const variant = location.state?.variant as IItemBaseVariant | undefined;
    const base = location.state?.base as IItemBase | undefined; 

    const queryExtractExportUrl: string = `${process.env.REACT_APP_BASE_URL}/${"extracts/download"}`;
    const queryExtractImportUrl: string = `${process.env.REACT_APP_BASE_URL}/${"extracts/upload"}`;
    const queryUrlSelect: string = `${process.env.REACT_APP_BASE_URL}/${"query/select/data?includeCount=true"}`;
    const publicAssetsUrl: string = `${process.env.REACT_APP_PUBLIC_ASSETS_URL}/`; 
    const fetchProductVariantActionsQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/PRODUCT_VARIANT_ACTIONS/run`; 
    const fetchProductVariantChannelActionsQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/PRODUCT_VARIANT_CHANNEL_ACTIONS/run`; 

    const [tableRows, setTableRows] = useState<React.ReactElement[]>([]);
    const [viewMode, setViewMode] = useState<'default' | 'edit' | 'seo' | 'channels' | 'history'>('default'); 
    
    const defaultQueryState: IQuerySelectData = { appCode: "sa_stock", selectCode: "product_variant_list", where: "", orderBy: "", pageNum: 0, pageSize: 100};    
    const [queryState, setQueryState] = useState<IQuerySelectData>(defaultQueryState);

    const defaultSearchState = { name: "", sku: "",  opts: "", price: "",  created: "", updated: ""};
    const [searchState, setSearchState] = useState<{ [key: string]: string }>(defaultSearchState);

    const [selectedVariant, setSelectedVariant] = useState<IItemBaseVariant | null>(null);
    const [selectedBaseProduct, setSelectedBaseProduct] = useState<IItemBase | null>(null); 

    // Keep snapshots to compare & revert
    const [selectedVariantImages, setSelectedVariantImages] = useState<{ id: string; url: string }[] | null>(null);
    const [selectedBaseProductImages, setSelectedBaseProductImages] = useState<{ id: string; url: string }[] | null>(null); 
    const [initialVariantAssets, setInitialVariantAssets] = useState<{ id: string; url: string }[]>([]);
    const [initialBaseAssets, setInitialBaseAssets] = useState<{ id: string; url: string }[]>([]);


    const [tableData, setTableData] = useState<IItemBaseVariant[]>([]);

    const [selectAllGlobal, setSelectAllGlobal] = useState(false);
    const [selectedRowIds, setSelectedRowIds] = useState<Set<string>>(new Set());


    const [channelView, setChannelView] = useState(""); // default to one
    const [previewImages, setPreviewImages] = useState<string[]>([]);


    //handling the opening of the images modal
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [selectedImages, setSelectedImages] = useState<string[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<string>("");
    const [carouselBaseImagesIndex, setCarouselBaseImagesIndex] = useState(0);

    const [isImportModalOpen, setIsImportModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    const [channelStatus, setChannelStatus] = useState<Record<string, boolean>>({
      "channel one": true,
      "channel two": false,
      "channel three": false,
      "channel four": true,
      "channel five": false,
    });

    //Form Data Settings 
    const [formDataVariantProductName, setFormDataVariantProductName] = useState<{id: string, sku: string, name: string}>({ id: "", sku: "", name: "",}); 
    const [initialFormDataVariantProductName, setInitialFormDataVariantProductName] = useState<{name: string }>({ name: "", });
    const [showSaveBanner, setShowSaveBanner] = useState<boolean>(false); 

    
     //Pagination Testing 
    const [pageNumber, setPageNumber] = useState<number>(0); 
    const [pageSize, setPageSize] = useState<number>(100);   
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [totalPages, setTotalPages] = useState<number>(0);


    //testing something with navigation 
    const [backToBaseProduct, setBackToBaseProduct] = useState<IItemBase | null>(null); 


    const [isProductImageModalOpen, setIsProductImageModalOpen] = useState(false);
    const [carouselIndex, setCarouselIndex] = useState(0);
    const [productType, setProductType] = useState("");

    // useEffect(() => {
    //     console.log(`=================================`);
    //     console.log(backToBaseProduct);
    //     console.log(`=================================`);
    // }, [backToBaseProduct]);

    useEffect(() => {
      if (variant) {
        handleSelectedItem(variant);
        setBackToBaseProduct(base ?? null); 
      } else {
        setViewMode("default");
      }
    }, [location.key]);

    useEffect(() => {
        if(viewMode === "default"){
            fetchVariantItems(); //fetch 
        }
    }, [queryState, viewMode]);

    // Pagination updates
    useEffect(() => {
        setQueryState(prev => ({
            ...prev,
            pageNum: pageNumber,
            pageSize: pageSize,
        }));
    }, [pageNumber, pageSize]);

    useEffect(() => {
      
      if(selectAllGlobal){
          // Display all selected IDs to exclude
          const allSelectedIds = Array.from(selectedRowIds); 
          console.log("All selected IDs across pages to exclude:", allSelectedIds);
      }

      if(!selectAllGlobal){
          // Display all selected IDs only
          const allSelectedIds = Array.from(selectedRowIds); 
          console.log("All selected IDs across the pages to specifically include:", allSelectedIds);
      }
     
    }, [tableData, selectedRowIds]);



    useEffect(() => {
      if (viewMode === "edit") {
        if (!selectedBaseProduct || !selectedVariant) return;

        const baseImages = selectedBaseProduct.product_base_assets || [];
        const variantImages = selectedVariant.product_base_assets || [];

        const filteredBaseAssets = baseImages.filter(
          baseAsset => !variantImages.some(variantAsset => variantAsset.id === baseAsset.id)
        );

        // set the images for the base and variant. 
        setSelectedBaseProductImages(filteredBaseAssets); 
        setSelectedVariantImages(variantImages); 

        // keeps proper “initial” snapshots of both lists
        setInitialBaseAssets(filteredBaseAssets); 
        setInitialVariantAssets(variantImages);
        
      }
    }, [selectedBaseProduct, selectedVariant, viewMode]);


    

    const fetchVariantItems = () => {
        fetchData(queryUrlSelect, {method:"POST", body: JSON.stringify(queryState)}, processData );
    }

    const processData = (result: any) => {
      
       // console.log(`variants data`, result);

        const data: IItemBaseVariant[] = [];

        for (const key in result.data) {
            const item = result.data[key];
            data.push({ ...item.data, ...item.control, id: item.id });
        }

        setTableData(data);
        // setCheckedRows(Array(data.length).fill(false));
        // setAllChecked(false); // reset header checkbox

        // Pagination 
        setPageSize(pageSize);
        setTotalRecords(result?.numRecords);
        setTotalPages(Math.ceil(result?.numRecords / pageSize));
    };

    //processing the base products data
    const processDataBase = (result: any) => {
      
        if (!result?.data?.length) {
            setSelectedBaseProduct(null);
            return;
        }

        const item = result.data[0]; // take the first item from data

        const baseProduct: IItemBase = {
            id: item.id,
            created: item.control?.created || null,
            updated: item.control?.updated || null,
            dirty: item.control?.dirty || false,
            touched: item.control?.touched || "",
            name: item.data?.name || "",
            description: item.data?.description || null,
            group_name: item.data?.group_name || null,
            opts: item.data?.opts || [],
            product_base_assets: item.data?.product_base_assets || null,
            product_variants: item.data?.product_variants || null,
            is_closed: item.data?.is_closed ?? null,
            channels: item.data?.channels || null,
            num_variants: item.data?.num_variants,
            slug: item.data?.slug
        };

        setSelectedBaseProduct(baseProduct);
    };


     const handleSelectedItem = ( item: IItemBaseVariant) => {

        //return is item is missing. 
        if (!item) return;

        // clearSearchClicked();
        // setPageNumber(0); 
        // setPageSize(100);   
        // setTotalRecords(0);
        // setTotalPages(0);

         // Set form data from item
        const newFormData = { id: item.id || "", sku: item.sku || "", name: item.name || ""};

        setFormDataVariantProductName(newFormData);
        setInitialFormDataVariantProductName(newFormData); 
    
        setSelectedVariant(item);
        setViewMode("edit");

        //get the base product of the variant: 
        fetchSelectedBaseProduct(item); 

    }


    const fetchSelectedBaseProduct = (item: IItemBaseVariant) => {

        if (!item.product_base_id) return; 

        const updatedQueryState: IQuerySelectData = {
              appCode: "sa_stock", 
              selectCode: "product_base_list",
              where: `id = :id`,
              params: { id: `${item.product_base_id}` }
        };

        fetchData(queryUrlSelect, { method:"POST", body: JSON.stringify(updatedQueryState)}, processDataBase ); 
    }


    const handleSearchOnChange = (event: ChangeEvent<HTMLInputElement>) => {
      const { id, value } = event.target;
      setSearchState((prev) => ({ ...prev, [id]: value.trim() }));
    };

    const handleViewImages = (images: { url: string }[]) => {
     setSelectedImages(images.map((img) => img.url));
     setIsImageModalOpen(true);
    };


    const handleRowToggle = (rowId: string) => {
      setSelectedRowIds(prev => {
        const updated = new Set(prev);
        if (updated.has(rowId)) {
          updated.delete(rowId);
        } else {
          updated.add(rowId);
        }
        return updated;
      });
    };

    const handleToggleAll = () => {
      const newSelectAll = !selectAllGlobal;
      setSelectAllGlobal(newSelectAll);
      setSelectedRowIds(new Set()); // reset any manual overrides
    };


    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.files && e.target.files[0]) {
        setSelectedFile(e.target.files[0]);
      } else {
        setSelectedFile(null);
      }
   };


   const generateWhereClause = (search: { [key: string]: string }) => {
      const clauses = Object.entries(search)
        .filter(([_, value]) => value.trim() !== "")
        .map(([key, value]) => {
          const sanitizedValue = value.replace(/'/g, "''");

          if (key === "price") {
            return !isNaN(Number(sanitizedValue))
              ? `${key} = ${Number(sanitizedValue)}`
              : `${key}::TEXT ILIKE '%${sanitizedValue}%'`;
          }

          if (key === "opts") {
            return `EXISTS (
              SELECT 1
              FROM jsonb_each_text(opts) AS kv(key, value)
              WHERE value ILIKE '%${sanitizedValue}%'
            )`;
          }

          if (key === "channels") {
            return `EXISTS (
              SELECT 1
              FROM jsonb_array_elements(channels) AS elem
              WHERE elem->>'code' ILIKE '%${sanitizedValue}%'
                AND (elem->>'is_enabled')::boolean = true
            )`;
          }

          return `${key} ILIKE '%${sanitizedValue}%'`;
        });

      return clauses.join(" AND ");
    };


    const searchClicked = () => {
        // Reset pagination state
        setPageNumber(0); // Reset page to first page
        setPageSize(100); // Reset page size to 100

        // Reset selection state
        setSelectAllGlobal(false);
        setSelectedRowIds(new Set());

        const whereClause = generateWhereClause(searchState);

        setQueryState(prev => ({
        ...prev,
        where: whereClause,
        pageNum: 0, // Ensure that the query state reflects the reset page number
        pageSize: 100, // Ensure the query state reflects the reset page size
        }));
    };
    
    const clearSearchClicked = () => {
        setSearchState(defaultSearchState);
        setQueryState(defaultQueryState);
    }    
    
    

    // Pagination handlers
    const goToFirstPage = () => setPageNumber(0);
    const goToPreviousPage = () => setPageNumber(prev => prev - 1);
    const goToNextPage = () => setPageNumber(prev => prev + 1);
    const goToLastPage = () => setPageNumber(totalPages - 1);

    // Update page size handler
    const handlePageSizeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
    };


    const getDynamicColumnsFromOpts = (optsArray: Record<string, string>[]): string[] => {
        const uniqueKeys = new Set<string>();
        for (const opts of optsArray) {
            Object.keys(opts).forEach((key) => uniqueKeys.add(key));
        }
        return Array.from(uniqueKeys);
    };


    const columnHeaders = [
        { key: 'image', label: 'Image' },
        { key: 'channels', label: 'Channels' },
        { key: 'sku', label: 'SKU' },
        { key: 'name', label: 'Name' },
        { key: 'opts', label: 'Opts' },
        { key: 'price', label: 'Price' },
        { key: 'actions', label: 'Actions' },
    ];

    const searchFields = [
        { name: 'channels', placeholder: 'Search Channel...' },
        { name: 'sku', placeholder: 'Search SKU...' },
        { name: 'name', placeholder: 'Search Name...' },
        { name: 'opts', placeholder: 'Search Opts...' },
        { name: 'price', placeholder: 'Search Price...' },
    ];


    function slugifyNameForUrl(name: string): string {
      return name
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')           // replace spaces with -
        .replace(/[^a-z0-9\-]/g, '')    // remove non-URL-safe characters
        .replace(/\-+/g, '-');          // collapse multiple dashes
    }






    const toggleChannel = (key: string) => {
      setChannelStatus((prev) => ({
        ...prev,
        [key]: !prev[key],
      }));
    };


   //handle the change of input values also based on the section thats been edited. 
    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, source: string) => {
      const { name, value } = e.target;
      const trimmedValue = typeof value === "string" ? value.trimStart() : value;

      if (source === "product_variant_name") {
        const updated = { ...formDataVariantProductName, [name]: trimmedValue };
        setFormDataVariantProductName(updated);

        // Compare to original
        const isChanged = updated.name !== initialFormDataVariantProductName.name;

        setShowSaveBanner(isChanged);
      }
    };

    /* 
    retail = 
    wholesale = 
    3PL = 
    */

    // ============================
    // Handling Edit Product Data
    // ============================

    //handle the clearing of the save / discard banner
    const handleClearBanner = () => {
        setFormDataVariantProductName({ id: "", sku: "", name: "" }); 
        setInitialFormDataVariantProductName({ name: "" });
        setSelectedVariantImages(null);
        setSelectedBaseProductImages(null); 
        setInitialVariantAssets([]);
        setInitialBaseAssets([]); 
        setShowSaveBanner(false); 
        setChannelView("");
    };

    //handle product variant name discard changes
    const handleProductVaraintNameDiscard = () => {
       setFormDataVariantProductName((prev) => ({
        ...prev,
        name: initialFormDataVariantProductName.name
      }));

      setSelectedVariantImages(initialVariantAssets);
      setSelectedBaseProductImages(initialBaseAssets); 
  
      setShowSaveBanner(false); 
    };


  // handle product variant name 'update' save changes
  const handleProductVaraintNameSave = () => { 
    if (formDataVariantProductName.name === "") return;

     const { id, ...rest } = formDataVariantProductName;

    const payload = {
      ...rest, // everything except
      name: rest.name.trim(),
      asset_ids: selectedVariantImages?.map(asset => asset.id) ?? [],
    };

    // local flag to detect if processData was called
    let callbackCalled = false;

    // perform PUT for the product variant name update
    fetchData(
      fetchProductVariantActionsQueryUrl,
      { method: "PUT", body: JSON.stringify(payload) },
      (result: any, status: string) => {
        callbackCalled = true; // mark callback as called
 

        console.log(`checking the result`);
        console.log(result);
        console.log(`====================`);

        if (status === "200" && selectedVariant) {
          // clearing the banner
          handleClearBanner();

          // Step 1: Re-fetch product variant 
          fetchData(
            queryUrlSelect,
            { method: "POST", body: JSON.stringify(queryState) },
            (result: any) => {
              const updatedVariantItems: IItemBaseVariant[] = [];

              for (const key in result.data) {
                const item = result.data[key];
                updatedVariantItems.push({ ...item.data, ...item.control, id: item.id });
              }

              // Step 2: Find the updated item and re-select it
              const updatedItem = updatedVariantItems.find(item => item.id === selectedVariant.id);
              if (updatedItem) {
                handleSelectedItem(updatedItem); // Re-fetch variant/line-level data
              }
            }
          );
        } else {
          console.log("Variant update failed (non-200 response)");
          handleProductVaraintNameDiscard(); 
        }
      },
      // clean callback (runs on both success / failure) 
      () => {
        if (!callbackCalled) { //trigger on failure
          console.log("Request failed before processData ran (network or non-OK).");
          handleProductVaraintNameDiscard(); 
        }
      }
    );
  };



   const cellStyle = {
    border: "none",
    padding: "0.75rem 0.5rem 0.75rem 1.2rem",
    verticalAlign: "middle",
    backgroundColor: "transparent",
  };

   const cellStyleImage = {
    border: "none",
    padding: "0.75rem 0.5rem 0.75rem 1.9rem",
    verticalAlign: "middle",
    backgroundColor: "transparent",
  };


const defaultTdStyle = {
  padding: "0.5rem",        // same as 8px
  border: "none",
  verticalAlign: "middle",     // default for <td>
  backgroundColor: "white", // or transparent depending on context
};

   const getChannelColor = (code: string) => {
    const baseColors: Record<string, string> = {
      AMAZON: '#FF9900',
      SHOPIFY: '#96BF48',
      TAKEALOT: '#0075B8',
      GOOGLE: '#4285F4',
      WOOCOMMERCE: '#96588A',
      POS: '#2b4a8c',
    };

    return baseColors[code.toUpperCase()] || '#ccc';
  };



const currentPageIds = tableData.map(row => row.id);

const allCurrentPageSelected = selectAllGlobal
  ? currentPageIds.every(id => !selectedRowIds.has(id)) // no overrides = all selected
  : currentPageIds.every(id => selectedRowIds.has(id));



  const exportProductVariantQuery: IQueryExtract = {
        sheetName: "",
        queryCreate: { 
          tableName: "sa_product_variant",
          select: [{ fullColumnName: "sku", aggregate: "" },
                   { fullColumnName: "name", aggregate: "" }, 
                   { fullColumnName: "price", aggregate: "" }],
          groupBy: [],
          join: [],
          orderBy: [ 
              {
                  fullColumnName: "sku",
                  direction: "ASC",
                  cast: CastType.STRING
              }
          ],
          where:[],
          mainTableOnly: false,
          includeExtraColumns: true,
          includeControlColumns: true,
          modifiedAfter: null,
          touchedBefore: null,
          isDirty: null,
          frontEndOnly: null,
          idSelect: null
      } 
    }


   const handleProductVariantExport = () => {
      const allSelectedIds = Array.from(selectedRowIds); // could be empty
      const whereConditions: typeof exportProductVariantQuery.queryCreate.where = [];
      const idSelectCondition: typeof exportProductVariantQuery.queryCreate.idSelect = {};

      // Step 1: Include search filters
      Object.entries(searchState).forEach(([key, rawValue]) => {
        const value = rawValue.trim();
        if (value === "") return;

        const sanitized = value.replace(/'/g, "''");

        if (key === "price") {
          if (!isNaN(Number(sanitized))) {
            whereConditions.push({
              fullColumnName: key,
              operator: "EQ",
              value: Number(sanitized),
            });
          } else {
            whereConditions.push({
              fullColumnName: `${key}::TEXT`,
              operator: "ILIKE",
              value: `%${sanitized}%`,
            });
          }
        } else if (key === "opts") {
          // idSelectCondition.params = [];
           if(!idSelectCondition.sql){
              idSelectCondition.sql = `SELECT id FROM sa_product_variant WHERE`;
           }else{
              idSelectCondition.sql += ` AND `;
           }
           
           idSelectCondition.sql += ` EXISTS (
                                      SELECT 1
                                      FROM jsonb_each_text(opts) AS kv(key, value)
                                      WHERE value ILIKE '%${sanitized}%'
                                    )`;

        } else if (key === "channels") {
           //idSelectCondition.params = [];
           if(!idSelectCondition.sql){
              idSelectCondition.sql = `SELECT id FROM sa_product_variant WHERE`;
           }else{
              idSelectCondition.sql += ` AND `;
           }

           idSelectCondition.sql += ` id IN (
                                         SELECT product_variant_id FROM sa_product_variant_channel
                                         JOIN sa_channel ON sa_product_variant_channel.channel_id = sa_channel.id
                                         WHERE sa_channel.code ILIKE '%${sanitized}%' AND sa_product_variant_channel.is_enabled = true 
                                      )`;

        } else {
          whereConditions.push({
            fullColumnName: key,
            operator: "ILIKE",
            value: `%${sanitized}%`,
          });
        }
      });

      // Step 2: Handle row selection logic
      if (selectAllGlobal) {
        if (allSelectedIds.length > 0) {
          // Select All is active but user deselected some → exclude them
          whereConditions.push({
            fullColumnName: "id",
            value: allSelectedIds,
            operator: "IN",
            not: true,
          });
        }
        // else: everything selected, no exclusion needed
      } else {
        if (allSelectedIds.length > 0) {
          // User selected specific rows → include only those
          whereConditions.push({
            fullColumnName: "id",
            value: allSelectedIds,
            operator: "IN",
            not: false,
          });
        } else {
          // Nothing selected manually → export everything that matches search filters
          // So we leave `whereConditions` as is (only search filters)
           console.log("Do nothing");
        }
      }

      const exportName = `pv_list`;
      
      idSelectCondition.params = [];
    
      // Finalize export query
      const finalExportQuery: IQueryExtract = {
        ...exportProductVariantQuery,
        sheetName: exportName,
        queryCreate: {
          ...exportProductVariantQuery.queryCreate,
          where: whereConditions,
          idSelect: idSelectCondition.sql ? idSelectCondition : null
        },
      };

      //console.log("Final Export Query:", finalExportQuery);
     
      fetchData(queryExtractExportUrl, 
        {method:"POST", body: JSON.stringify(finalExportQuery)}, 
        (result: any, status: string) => {
            if(status === "200" || status === "201"){
                productVaraintExcelList(result);
            }
        });
    };

    const productVaraintExcelList = async (result: any) => {
        const now = new Date();
        const timestamp = now.toISOString().replace(/[:.]/g, "-").replace("T", "_").replace("Z", "");
        const fileName = `pv_list_${timestamp}.xlsx`;

        // Create a download link for the Blob
        const url = URL.createObjectURL(result);
        // Create a temporary <a> element to trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // Set the default filename here
        document.body.appendChild(a);
        a.click();
    } 


    const handleFileImportSubmit = () => {
      if (!selectedFile) return;

        // how to do a multipe part form posts javascript  
        const formData = new FormData();
        formData.append('file', selectedFile);
        
        const headers = new Headers();
        headers.append("Content-Type", "multipart/formdata"); 

        
        fetchData(queryExtractImportUrl, 
          {method:"POST", body: formData, headers: headers }, 
          (result: any, status: string) =>  { 
            if(status === "200"){
                //we will have to refect all the products 
                setSelectAllGlobal(false);
                setSelectedRowIds(new Set());
                fetchVariantItems();
            }
          });

      // Optional: Reset and close modal
      setSelectedFile(null);
      setIsImportModalOpen(false);
    };

    const handleSubmitResourceFiles = () => {
        console.log(previewImages); 
    }


    



    const handleBackToProductVariants = () => {

        setViewMode("default");
        handleClearBanner();
        setSelectedVariant(null);
        setSelectedBaseProduct(null); 
        setChannelView("");
    }


   // ---------------------------------------------------------------- //
   // PRODUCT VARIANTS IMAGE HANDLING
   // ---------------------------------------------------------------- //

    // sensors for drag and drop minimul 5px movement
    const sensors = useSensors(
      useSensor(PointerSensor, {
        activationConstraint: {
          distance: 5, // require small movement to start drag
        },
      })
    );

    const handleDragEnd = (event: any) => {
        const { active, over } = event;
        if (!over || active.id === over.id) return;

        if (!selectedVariantImages) return;

        const oldIndex = selectedVariantImages.findIndex(i => i.id === active.id);
        const newIndex = selectedVariantImages.findIndex(i => i.id === over.id);

        if (oldIndex === -1 || newIndex === -1) return;

        const updated = arrayMove(selectedVariantImages, oldIndex, newIndex);

        setSelectedVariantImages(updated);

        // Trigger Save/Discard banner if the order changed
        if (initialVariantAssets) {
          const changed =
            updated.length !== initialVariantAssets.length ||
            !updated.every((img, index) => img.id === initialVariantAssets[index]?.id);
          setShowSaveBanner(changed || formDataVariantProductName.name !== initialFormDataVariantProductName.name);
        }
    };


    const style: React.CSSProperties = {
          width: "100px",
          height: "100px",
          border: "1px solid #ccc",
          borderRadius: "10px",
          overflow: "hidden",
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
         
          flexShrink: 0,
          marginRight: "10px",
          background: "#fff",
      };

    const moveDownStyle: React.CSSProperties = {
            position: "absolute",
            top: "4px",
            right: "4px",
            width: "20px",           
            height: "20px",          
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(0,0,0,0.55)",
            borderRadius: "50%",
            cursor: "pointer",
            zIndex: 10,
            touchAction: "none",
        };
     

    // Move image from base → variant
    const handleMoveToVariant = (assetId: string) => {
      if (!selectedBaseProductImages || !selectedVariantImages) return;

      const assetToMove = selectedBaseProductImages.find(img => img.id === assetId);
      if (!assetToMove) return;

      const updatedBase = selectedBaseProductImages.filter(img => img.id !== assetId);
      const updatedVariant = [...selectedVariantImages, assetToMove];

      setSelectedBaseProductImages(updatedBase);
      setSelectedVariantImages(updatedVariant);

      // Check for changes
      checkVariantImagesChanged(updatedVariant, updatedBase);
    };

    // Move image from variant → base
    const handleMoveToBase = (assetId: string) => {
      if (!selectedBaseProductImages || !selectedVariantImages) return;

      const assetToMove = selectedVariantImages.find(img => img.id === assetId);
      if (!assetToMove) return;

      const updatedVariant = selectedVariantImages.filter(img => img.id !== assetId);
      const updatedBase = [...selectedBaseProductImages, assetToMove];

      setSelectedBaseProductImages(updatedBase);
      setSelectedVariantImages(updatedVariant);

      // Check for changes
      checkVariantImagesChanged(updatedVariant, updatedBase);
    };

    // Utility to check if images changed
    const checkVariantImagesChanged = (variantImages: { id: string; url: string }[] | null, baseImages: { id: string; url: string }[] | null) => {
    
      const variantChanged =
        (variantImages?.length ?? 0) !== (initialVariantAssets?.length ?? 0) ||
        !(variantImages ?? []).every(
          (img, index) => img.id === initialVariantAssets?.[index]?.id
        );

      const baseChanged =
        (baseImages?.length ?? 0) !== (initialBaseAssets?.length ?? 0) ||
        !(baseImages ?? []).every(
          (img, index) => img.id === initialBaseAssets?.[index]?.id
        );

      setShowSaveBanner(variantChanged || baseChanged || formDataVariantProductName.name !== initialFormDataVariantProductName.name);
    };

    // ---------------------------------------------------------------- //
    // ---------------------------------------------------------------- //


    const handleToggleChannel = ( variant_id: string, channel_id: string, is_enabled: boolean) => {

      if(variant_id === "" || channel_id === "") return; 

      const payload = { 
           product_variant_id: variant_id,
           channel_id: channel_id,
           is_enabled: is_enabled
      } 
      
    // local flag to detect if processData was called
     let callbackCalled = false;

    
    fetchData(
      fetchProductVariantChannelActionsQueryUrl,
      { method: "PUT", body: JSON.stringify(payload)},
      (result: any, status: string) => {
        callbackCalled = true; // mark callback as called

        if (status === "200" && selectedVariant) {

          const { ...rest } = queryState;
          const updatedQueryState: IQuerySelectData = { ...rest, where: `id = :id`, params: { id: `${selectedVariant?.id}` }};

          fetchData(queryUrlSelect, { method: "POST", body: JSON.stringify(updatedQueryState) }, (result: any) => {

            if (result?.data?.length) {
                const itemData = result.data[0].data;

                // Map it to IItemBaseVariant
                const selectedItem: IItemBaseVariant = {
                    id: result.data[0].id,
                    created: result.data[0].control.created,
                    updated: result.data[0].control.updated,
                    dirty: result.data[0].control.dirty,
                    touched: result.data[0].control.touched,
                    product_base_id: itemData.product_base_id, 
                    opts: itemData.opts,
                    product_base_assets: itemData.product_base_assets,
                    price: itemData.price,
                    name: itemData.name, 
                    sku: itemData.sku, 
                    is_closed: itemData.is_closed,
                    locations: itemData.locations, 
                    channels: itemData.channels
                };


                setSelectedVariant(selectedItem); 
                setViewMode('channels');
              }
          });
          
        } else {
          console.log("Variant update failed (non-200 response)");
        }
      },
      // clean callback (runs on both success / failure) 
      () => {
        if (!callbackCalled) { //trigger on failure
          console.log("Request failed before processData ran (network or non-OK).");
        }
      }
    );
  }

    //functions/PRODUCT_VARIANT_CHANNEL_ACTIONS/run 

    // console.log(`============ Selected Varaint ==============`);
    // console.log(selectedVariant);
    // console.log(`================= ==============`);

  const handleNavigateToBaseProduct = (base: IItemBase) => {
      navigate("/products", { state: { base: base } });
      setBackToBaseProduct(null);
  }

  
  const handleCloseAndResetModal = (from : string) => {
    if(from === "default-gallery"){
      setSelectedImages([]);
      setIsImageModalOpen(false);
      setCarouselBaseImagesIndex(0);
      setSelectedProduct("");
    }

    if(from === "edit-gallery"){
      setIsProductImageModalOpen(false); 
      setProductType("");
      setCarouselIndex(0);
    }
  }
  

  return(
        <React.Fragment>
          { showErrorAlert && <ShowErrorAlert message={responseErrorMessage} /> } 
            <Container fluid className="p-0">
                 {viewMode === "default" && 
                 <Card>
                    <Card.Header style={{ padding: '15px 0px 0px 20px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <Card.Title>Product Variants</Card.Title>
                        <div className="d-flex gap-2 me-3">
                          <button
                            className="btn btn-outline-secondary btn-sm"
                            title="Import Variants"
                            onClick={() => {
                              setIsImportModalOpen(true);
                            }}
                          >
                            <Upload size={16} />
                          </button>
                          <button
                            className="btn btn-outline-secondary btn-sm"
                            title="Export Variants"
                            onClick={handleProductVariantExport}
                          >
                            <Download size={16} />
                          </button>
                        </div>
                      </div>
                    </Card.Header>
                   <CardBody>
                       <div>
                            <div style={{ width: '100%',  padding: '4px 8px', backgroundColor: 'white',   }}>
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-row gap-2" style={{marginTop: '14px'}}>
                                            <h6 className="card-subtitle text-muted">Total Records: {totalRecords} </h6> 
                                            <h6 className="card-subtitle text-muted">Current Page :  [{ pageNumber + 1 } of {totalPages}]</h6> 
                                        </div>

                                        <div className="d-flex align-items-center gap-3">
                                            {/* // Page Size */}
                                            <nav aria-label="">
                                                <ul className="pagination m-0">
                                                    <li className="page-item">
                                                        <select className="page-link" 
                                                            value={pageSize}
                                                            onChange={handlePageSizeChange}
                                                            style={{width: '100px', textAlign: 'center', padding: '10px'}}>
                                                            <option defaultChecked value={pageSize}>{pageSize}</option>
                                                            {[25, 50, 75, 100, 150, 200, 250, 500, 750, 1000].map(size => (
                                                              <option key={size} value={size}>{size}</option>
                                                            ))}
                                                        </select>
                                                    </li>                            
                                                </ul>
                                            </nav>

                                            {/* // Pagination Control */}
                                               <nav aria-label="">
                                                <ul className="pagination m-0">
                                                  <li className={`page-item ${pageNumber === 0 ? 'disabled' : ''}`}>
                                                    <button 
                                                      className="page-link d-flex align-items-center justify-content-center gap-1"
                                                      onClick={goToFirstPage}
                                                      disabled={pageNumber === 0}
                                                      style={{ height: '38px', marginTop: '1px' }}
                                                    >
                                                      <ChevronsLeft size={18} />
                                                    </button>
                                                  </li>
  
                                                  <li className={`page-item ${pageNumber <= 0 ? 'disabled' : ''}`}>
                                                    <button 
                                                      className="page-link d-flex align-items-center justify-content-center"
                                                      onClick={goToPreviousPage}
                                                      disabled={pageNumber <= 0}
                                                      style={{ height: '38px', marginTop: '1px' }}
                                                    >
                                                      <ChevronLeft size={18} />
                                                    </button>
                                                  </li>
  
                                                  <li className="page-item">
                                                    <span
                                                      className="page-link d-flex align-items-center justify-content-center"
                                                      style={{ height: '38px', marginTop: '1px', padding: '0 14px' }}
                                                    >
                                                      Page {pageNumber + 1} of {totalPages}
                                                    </span>
                                                  </li>
  
                                                  <li className={`page-item ${pageNumber >= totalPages - 1 ? 'disabled' : ''}`}>
                                                    <button 
                                                      className="page-link d-flex align-items-center justify-content-center"
                                                      onClick={goToNextPage}
                                                      disabled={pageNumber >= totalPages - 1}
                                                      style={{ height: '38px', marginTop: '1px' }}
                                                    >
                                                      <ChevronRight size={18} />
                                                    </button>
                                                  </li>
  
                                                  <li className={`page-item ${pageNumber >= totalPages - 1 ? 'disabled' : ''}`}>
                                                    <button 
                                                      className="page-link d-flex align-items-center justify-content-center gap-1"
                                                      onClick={goToLastPage}
                                                      disabled={pageNumber >= totalPages - 1}
                                                      style={{ height: '38px', marginTop: '1px' }}
                                                    >
                                                      <ChevronsRight size={18} />
                                                    </button>
                                                  </li>
                                                </ul>
                                              </nav>

                                        </div>
                                </div>
                            </div>
                            <div className="table-responsive">
                            <table className="table table-md table-hover-light w-100 mb-0">
                                {/* FILTER INPUTS HEADER */}
                                <thead>
                                  <tr>
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px' }}></th> 
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px' }}></th>
                                     { searchFields.map(({ name, placeholder }) => (
                                         <td key={name} style={{ backgroundColor: 'white', padding: '4px 8px' }}>
                                          <input id={name} name={name} value={searchState[name] ?? ''} onChange={handleSearchOnChange} type="text" autoComplete="off"  placeholder={placeholder} className="form-control form-control-md" />
                                        </td>
                                    ))}
                                    <th style={{ backgroundColor: 'white', padding: '4px 8px', width:'120px' }}>
                                         <div className="d-flex justify-content-end gap-1 w-100">
                                          <button
                                            type="button"
                                            className="btn btn-outline-danger btn-md d-flex justify-content-center align-items-center"
                                            onClick={searchClicked}
                                          >
                                            <Search style={{ width: '20px', height: '20px' }} strokeWidth={2} />
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-outline-secondary btn-md d-flex justify-content-center align-items-center"
                                            onClick={clearSearchClicked}
                                          >
                                            <X style={{ width: '20px', height: '20px' }} strokeWidth={2} />
                                          </button>
                                        </div>
                                      </th>
                                  </tr>
                                </thead>
                                <thead>
                                    <tr>
                                      <td style={{ fontWeight: "600", backgroundColor: "white", border: 'none', display: "flex", justifyContent: "center", alignItems: "center", height: "40px" }}>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          checked={currentPageIds.length > 0 && allCurrentPageSelected}
                                          onChange={handleToggleAll}
                                        />
                                      </td>
                                        {columnHeaders.map(({ key, label }, index) => (
                                        <th
                                          key={key}
                                          style={{
                                            fontWeight: "600",
                                            backgroundColor: "white",
                                            paddingLeft: "20px",
                                            ...(index === columnHeaders.length - 1 && { borderRight: '1px solid #deebed' }),
                                          }}
                                        >
                                          {label}
                                        </th>
                                      ))}
                                    </tr>
                                </thead>
                                <tbody>
                        
                                   {tableData.map((record, index) => {

                                    const { id, name, sku, price, product_base_assets, channels, opts,  is_closed } = record;
                                    const cellStyle: React.CSSProperties = { whiteSpace: 'nowrap', padding: '4px 6px', fontSize: '0.75rem', verticalAlign: 'middle', borderRight: 'none', borderLeft: 'none', borderTop:'1px solid #deebed', borderBottom:'1px solid #deebed' };

                                    const isRowChecked = selectAllGlobal ? !selectedRowIds.has(record.id) : selectedRowIds.has(record.id); // explicitly selected
  
                                    return (
                                          <tr id={`${index}`} key={id}>
                                                <td style={{ ...cellStyle, textAlign: 'center', padding: '0' }}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60px', paddingBottom: '4px' }}>
                                                  <input
                                                    type="checkbox"
                                                    checked={isRowChecked}
                                                    className="form-check-input"
                                                    onChange={() => handleRowToggle(id)}
                                                  />
                                                </div>
                                              </td>
                                            <td style={cellStyle}>
                                              <div className="table-image-container" 
                                                style={{ position: 'relative', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '40px', maxHeight: '60px', overflow: 'hidden', boxShadow: 'none' }}
                                                onMouseEnter={(e) => {
                                                  const icon = e.currentTarget.querySelector('.hover-search-icon') as HTMLDivElement;
                                                  if (icon) icon.style.opacity = '1';
                                                }}
                                                onMouseLeave={(e) => {
                                                  const icon = e.currentTarget.querySelector('.hover-search-icon') as HTMLDivElement;
                                                  if (icon) icon.style.opacity = '0';
                                                }}
                                                >
                                                {Array.isArray(product_base_assets) && product_base_assets.length > 0 ? (
                                                  <>
                                                    <img src={`${publicAssetsUrl}${product_base_assets[0].url}`} alt={name} title={name}
                                                      style={{ maxHeight: '40px', maxWidth: '100%', borderRadius: '4px', objectFit: 'contain', display: 'block'}}
                                                      onClick={() => handleSelectedItem(record)}
                                                      onError={(e) => (e.currentTarget.style.display = 'none')}
                                                    />
                                
                                                    {/* Search icon, shown on hover only (via opacity, not display) */}
                                                    <div className="hover-search-icon" 
                                                      style={{opacity: 0,transition: 'opacity 0.2s ease', position: 'absolute', top: '0px', right: '0px', cursor: 'pointer', zIndex: 10}}
                                                      onClick={(e) => { e.stopPropagation(); handleViewImages(product_base_assets); setSelectedProduct(name); }}
                                                    >
                                                      <Search size={16} color="#555" />
                                                    </div>
                                                  </>
                                                ) : (
                                                  <div style={{width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => handleSelectedItem(record)} >
                                                      <ImageOff size={24} color="#ccc" />
                                                  </div>
                                                )}
                                              </div>
                                            </td>
                                             <td style={{ ...cellStyle, paddingLeft: '21px' }}>
                                             {Array.isArray(channels) && channels.length > 0 ? (
                                              <div style={{ display: 'flex', gap: '6px', flexWrap: 'nowrap', overflow: 'hidden' }}>
                                                {channels.slice(0, 5).map(channel => (
                                                  <span
                                                    key={channel.id}
                                                    title={`${channel.code}`}
                                                    style={{
                                                      width: '12px',
                                                      height: '12px',
                                                      borderRadius: '50%',
                                                      backgroundColor: channel.is_enabled ? getChannelColor(channel.code) : 'white',
                                                      border: `2px solid ${getChannelColor(channel.code)}`,
                                                      flexShrink: 0
                                                    }}
                                                  />
                                                ))}
                                                {channels.length > 5 && (
                                                  <span style={{ whiteSpace: 'nowrap' }}>…</span>
                                                )}
                                              </div>
                                            ) : null}
                                          </td>
                                            <td style={{...cellStyle, paddingLeft: '20px'}} title={sku}>{sku}</td>
                                            <td style={{ ...cellStyle, position: 'relative', paddingLeft: '20px' }} title={name}>
                                              <div style={{ maxWidth: '220px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                <span>{name}</span>
                                              </div>
                                              {is_closed && (
                                                <span
                                                  className="badge"
                                                  title="This item is disabled"
                                                  style={{
                                                    position: 'absolute',
                                                    top: '4px',
                                                    right: '0px',
                                                    fontSize: '0.65rem',
                                                    borderRadius: '6px',
                                                    padding: '2px 6px',
                                                    backgroundColor: '#f72832',
                                                    zIndex: 1
                                                  }}
                                                >
                                                  Disabled
                                                </span>
                                              )}
                                            </td>

                                         
                                           <td
                                            style={{ ...cellStyle, paddingLeft: '20px' }}
                                            title={Object.entries(opts)
                                              .filter(([_, v]) => v !== null && v !== '')
                                              .map(([k, v]) => `${k}: ${v}`)
                                              .join(', ')
                                            }
                                           
                                          >
                                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                              {Object.entries(opts)
                                                .filter(([_, v]) => v !== null && v !== '')
                                                .slice(0, 3)
                                                .map(([key, value]) => (
                                                  <div
                                                    key={key}
                                                    style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}
                                                  >
                                                    <strong>{key}:</strong> {value}
                                                  </div>
                                                ))}
                                              {Object.entries(opts).filter(([_, v]) => v !== null && v !== '').length > 3 && (
                                                <span style={{ whiteSpace: 'nowrap' }}>…</span>
                                              )}
                                            </div>
                                          </td>
                                            <td style={{...cellStyle, paddingLeft: '20px'}} title={`${price}`} >{price}</td>
                                            <td style={{...cellStyle, paddingLeft: '20px'}}>
                                              <button className="btn btn-outline-secondary btn-sm pt-1 pb-1 d-flex align-items-center gap-1 rounded" title="Edit" onClick={() => handleSelectedItem(record)}>
                                                 <Pencil size={16} />
                                              </button>
                                            </td>
                                        </tr>
                                    );
                                  })}
                                    
                                </tbody>
                              </table>
                              </div>
                            </div>
                   </CardBody>
                 </Card>
                }

                 { viewMode !== "default" && 
                 <Card>
                   <Card.Header style={{ padding: "15px 20px 0px 20px", position: "relative", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <button className="custom-back-btn" title={`${!backToBaseProduct ? 'Back To Product Variants' : 'Back To Base Product'}`} 
                        onClick={() => { 
                          if(!backToBaseProduct) {
                            handleBackToProductVariants(); 
                          }else{
                            handleNavigateToBaseProduct(backToBaseProduct);
                          }
                        }}> 
                        { !backToBaseProduct ? ( <X className="back-btn-svg" size={18}  /> ) : (<ArrowLeft className="back-btn-svg" size={18}  />)}
                      </button> 
                      <Card.Title style={{ margin: 0 }}>Product Variant View</Card.Title>
                    </div>
                    {showSaveBanner && (
                      <div className="save-banner">
                          <span className="save-message">You have unsaved changes:</span>
                          <button className="banner-buttons" onClick={handleProductVaraintNameSave}>
                              <span>Save</span>
                          </button>
                          <button className="banner-buttons" onClick={handleProductVaraintNameDiscard}>
                              <span>Discard</span>
                          </button>
                      </div>
                    )}
                  </Card.Header>
                  
                   <Card.Body style={{ backgroundColor:"#f5f7fa" , borderRadius: "0 0 0.5rem 0.5rem", margin:'10px 4px 4px 4px', border:'1px solid #e1e5ec'}}>
                    <div className="d-flex border-bottom mb-4" style={{ gap: '1rem' }}>
                     {[
                        { key: 'edit', label: 'Edit Product Variant' },
                        { key: 'seo', label: 'SEO Settings', disabled: true },
                        { key: 'channels', label: 'Channels' , disabled: false},
                        { key: 'history', label: 'History', disabled: true },
                      ].map(({ key, label, disabled }) => (
                      <button
                          key={key}
                          className={`border-0 bg-transparent fw-semibold px-3 pb-2 position-relative ${
                            viewMode === key ? 'text-primary' : 'text-muted'
                          } ${disabled ? 'text-muted opacity-50 cursor-default' : 'cursor-pointer'}`}
                          style={{
                            fontSize: '0.85rem',
                            borderBottom: viewMode === key ? '3px solid #0d6efd' : '3px solid transparent',
                            transition: 'all 0.3s ease',
                            pointerEvents: disabled ? 'none' : 'auto',
                          }}
                          disabled={disabled}
                          onClick={() => {
                            if (!disabled) setViewMode(key as typeof viewMode);
                            if (viewMode !== "edit") handleProductVaraintNameDiscard(); 
                            setChannelView("");
                          }}
                        >
                          {label}
                        </button>
                    ))}
                  </div>

                    { viewMode === "edit" && selectedVariant && (
                      <> 
                    
                       <div className="d-flex align-items-center justify-content-between border-bottom mb-2">
                          <h6 className="modal-title text-uppercase text-secondary fw-bolder" style={{ paddingLeft: "4px" }}>
                            Product Information:
                          </h6>
                       </div>

                       {/* Product Name */}
                       <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                        <label htmlFor="productTitle" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Product Name </label>
                        <input type="text" className="form-control" name="name" value={formDataVariantProductName.name} onChange={(e) => handleOnChange(e, "product_variant_name")} />
                      </div>

                       <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                        <label htmlFor="productSku" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Product Sku</label>
                        <input type="text" className="form-control" name="sku" value={selectedVariant.sku} disabled/>
                      </div>

                       {Object.keys(selectedVariant.opts).map((optionKey) => (
                        <div key={optionKey} className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor={`Product ${optionKey}`} className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Product {optionKey.charAt(0).toUpperCase() + optionKey.slice(1)}</label>
                          <input type="text" className="form-control" name={`${optionKey}`} value={selectedVariant.opts[optionKey]} disabled/>
                        </div>
                        ))}

                      <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                        <label htmlFor="productPrice" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Product Price</label>
                        <input type="text" className="form-control" name="price" value={selectedVariant.price} disabled/>
                      </div>
                    

                      <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom mb-2" style={{ paddingLeft: "4px" }}>
                         Product Image Information:
                      </h6>


                      <div className="mb-4 mt-2" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem", border: "1px solid #e1e5ec" }}>
                        <label className="form-label fw-semibold" style={{ paddingLeft: "1.9rem" }}>Product Variant Images Available</label>
                        <div style={{margin: "0px 20px"}}>
                          {selectedBaseProductImages && selectedBaseProductImages.length > 0 && 
                           <div style={{ display: "flex", overflowX: "auto", padding: "10px", whiteSpace: "nowrap" }}>
                             { selectedBaseProductImages.map((asset, index) => ( 
                                <div key={asset.id}  style={style} onClick={(e) => { 
                                      e.stopPropagation();
                                      setCarouselIndex(index); 
                                      setIsProductImageModalOpen(true); 
                                      setProductType("base_assets"); 
                                    }} 
                                  >
                                  <div style={moveDownStyle} 
                                      data-no-drag
                                      onClick={(e) => {
                                          e.stopPropagation();
                                          handleMoveToVariant(asset.id);
                                      }}
                                      onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(0, 0, 0, 0.8)")}
                                      onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(0, 0, 0, 0.6)")}
                                      >
                                      <ArrowDown color="#fff" style={{ width: "15px", height: "15px", paddingRight:'1px', paddingTop:'1px' }} />
                                    </div>
                                    <img src={`${publicAssetsUrl}${asset.url}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", pointerEvents: "none"  }} />
                                </div>
                              ))}
                            </div>
                            }
                           <hr style={{margin: "0px 10px"}} />
                            <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", margin: "10px 0", padding: "0 10px" }}>
                              <div style={{ display: "flex", gap: "8px" }}></div>
                              <span style={{ fontSize: "12px" }}>
                                Total Images: <b>{selectedBaseProductImages?.length}</b>
                              </span>
                            </div>
                            <hr style={{ margin: "0px 10px" }} />
                        </div>
                      </div>

                       <div className="mb-4 mt-2" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem", border: "1px solid #e1e5ec" }}>
                        <label className="form-label fw-semibold" style={{ paddingLeft: "1.9rem" }}>Product Variant Images Selected</label>
                         <div style={{margin: "0px 20px"}}>
                              {selectedVariantImages && selectedVariantImages.length > 0 && 
                                <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                                  <SortableContext items={selectedVariantImages} strategy={horizontalListSortingStrategy}>
                                    <div style={{ display: "flex", overflowX: "auto", padding: "10px", whiteSpace: "nowrap" }}>
                                      { selectedVariantImages.map((asset, index) => ( 
                                          <div key={asset.id} onClick={(e) => { 
                                            e.stopPropagation();
                                            setCarouselIndex(index); 
                                            setIsProductImageModalOpen(true); 
                                            setProductType("variant_assets"); 
                                           }} 
                                            style={{ cursor: "pointer" }}>
                                          <SortableProductVariantImages 
                                            key={asset.id} 
                                            asset={asset} 
                                            publicAssetsUrl={publicAssetsUrl} 
                                            onMoveUp={handleMoveToBase}
                                          /> 
                                        </div>
                                      ))}
                                    </div>
                                  </SortableContext>
                                </DndContext>
                               }
                              <hr style={{margin: "0px 10px"}} />
                              <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", margin: "10px 0", padding: "0 10px" }}>
                                <div style={{ display: "flex", gap: "8px" }}></div>
                                <span style={{ fontSize: "12px" }}>
                                  Total Images: <b>{selectedVariantImages?.length}</b>
                                </span>
                              </div>
                              <hr style={{ margin: "0px 10px" }} />
                          </div>
                       </div>
                      
                      </>
                    )}

                    
                    { viewMode === "seo" && selectedVariant && (
                       <>

                        <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom mb-2" style={{ paddingLeft: "4px" }}>
                          Product Information:
                        </h6>

                       
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productTitle" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Product Name</label>
                          <input type="text" className="form-control" value={selectedVariant.name} id="productTitle" placeholder="Enter product name" disabled />
                        </div>
                       
                        <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom mb-2" style={{ paddingLeft: "4px" }}>
                          SEO Information:
                        </h6>

                         
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productTitle" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Meta Tag Title</label>
                          <input type="text" className="form-control"  placeholder="Enter product meta tag title" disabled />
                        </div>

                         
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productDescription" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Meta Tag Description</label>
                          <textarea className="form-control" rows={6} placeholder="Write a detailed meta tag description..."  disabled/>
                        </div>

                       
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productDescription" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Meta Tag Keywords</label>
                          <textarea className="form-control"  rows={6} placeholder="Write a detailed meta tag keywords..."  disabled/>
                        </div>

                      
                        <p className="text-muted" style={{ paddingLeft: "1.6rem" }}><b>Suggest Url Slug:</b> {`${slugifyNameForUrl(selectedVariant.name)}`}</p>
                        
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productTitle" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Url Slug</label>
                          <input type="text" className="form-control"  placeholder="Enter url slug" disabled />
                          <p style={{ paddingLeft: "0.75rem" }} className="text-muted d-block mt-2">A URL slug is the last part of the URL address that serves as a unique identifier of the page.</p>
                        </div>
                      </>
                    )} 

                     { viewMode === "channels" && selectedVariant && (
                      <>
                       <div className="mb-4">
                        <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom" style={{ paddingLeft: "4px" }}>
                          Channel Status Overview:
                        </h6>

                        <div className="table-responsive bg-white p-1 rounded shadow-sm border mt-2">
                          <table className="table table-sm align-middle mb-0">
                            <thead className="bg-light text-muted">
                              <tr>
                                <th style={{ width: "30%", background: "rgb(41, 48, 66)", color: "white" }}>Channel</th>
                                <th style={{ width: "20%", background: "rgb(41, 48, 66)", color: "white" }}>Status</th>
                                <th style={{ width: "20%", background: "rgb(41, 48, 66)", color: "white" }}>Toggle</th>
                              </tr>
                            </thead>
                             <tbody>
                                 { selectedVariant.channels?.map(({ id, code, is_enabled}) => {
                                  return (
                                    <tr key={id} >
                                       <td>{code}</td>
                                        <td>
                                           <span className={`badge ${is_enabled ? "bg-success" : "bg-secondary"}`}>
                                            {is_enabled ? "ENABLED" : "DISABLED"}
                                          </span>
                                        </td>
                                        <td>
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={id}
                                              checked={is_enabled}
                                              onChange={() => handleToggleChannel(selectedVariant.id, id, !is_enabled)}
                                            />
                                          </div>
                                        </td>
                                    </tr>
                                   );
                                 })}
                              </tbody>
                          </table>
                        </div>
                      </div>
                      <div>
                        {/* <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom" style={{ paddingLeft: "4px" }}>
                             Channel Settings:
                        </h6> */}
                        {/* <div className="d-flex flex-column flex-md-row gap-4 mt-2">
                            <div className="d-flex flex-md-column border-bottom border-top border-md-0 border-end pe-md-4 gap-2 gap-md-0" style={{ minWidth: "180px", flexShrink: 0 }}>
                              { selectedVariant.channels?.map(({ id, code, is_enabled}) => {
                                  const isActive = channelView === code; 
                                  return (
                                  <button
                                      key={id}
                                      className={`border-0 bg-transparent fw-semibold px-3 py-2 text-start position-relative w-100 ${
                                        isActive ? "text-primary" : "text-muted"
                                      }`}
                                      style={{
                                        fontSize: "0.85rem",
                                        borderLeft: isActive ? "3px solid #0d6efd" : "3px solid transparent",
                                        backgroundColor: isActive ? "#f8f9fa" : "transparent",
                                        transition: "all 0.3s ease",
                                      }}
                                      onClick={() => setChannelView(code)}
                                    >
                                      {code}
                                    </button>
                                  );
                                })}
                          </div>

                      
                          <div className="flex-grow-1">
                             {selectedVariant.channels?.filter(({ code }) => code === channelView)
                              .map(({ code }) => (
                                <div key={code}>
                                  <p>{`${code} content goes here...`}</p>
                                </div>
                              ))}
                          </div>
                         </div> */}
                        </div>
                      </>
                    )} 

                   { viewMode === "history" && selectedVariant && (
                      <>
                         <p className="text-muted mb-4" style={{paddingLeft: "4px"}}>You are in product history mode...</p>
                      </>
                    )} 
                  </Card.Body>
                </Card>
                } 

             {isImportModalOpen && (
              <div className="modal d-block" tabIndex={-1} onClick={() => setIsImportModalOpen(false)} style={{ background: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-content position-relative">
                    <div className="modal-header">
                      <h5 className="modal-title text-uppercase text-secondary fw-bolder ">
                            Import Product Variant List: 
                      </h5>
                      <button type="button" className="btn-close"
                        onClick={() => {
                          setIsImportModalOpen(false);
                        }}
                      />
                    </div>
                     <div className="modal-body d-flex flex-column align-items-center gap-3">
                        <input type="file" className="form-control" accept=".xlsx,.csv" onChange={handleFileChange}/>
                        {selectedFile && ( <p className="text-muted small"> Selected file: <strong>{selectedFile.name}</strong></p>)}
                      </div>
                      <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={() => setIsImportModalOpen(false)}>
                          Cancel
                        </button>
                        <button className="btn btn-primary" disabled={!selectedFile} onClick={handleFileImportSubmit}>
                          Upload File
                        </button>
                      </div>
                  </div>
                </div>
              </div>
             )}



                
           {isImageModalOpen && (
            <div className="modal d-block modal-images-gallery-carousel" tabIndex={-1} onClick={() => handleCloseAndResetModal("default-gallery")}>
               <div className="modal-dialog modal-xl modal-dialog-centered images-gallery-carousel-content" onClick={(e) => e.stopPropagation()}>
                 <div className="modal-content position-relative images-gallery-carousel-inner">
                  {/* HEADER */}
                   <div className="modal-header border-0 pb-2 pt-3 px-4 header-content">
                     <h5 className="modal-title fw-semibold mb-0 header-title">
                      <span className="title">Product</span>
                      <span className="product">{selectedProduct}</span>
                    </h5>

                    <button className="close-gallery-btn" type="button" onClick={() => handleCloseAndResetModal("default-gallery")}>
                      ✕
                    </button>
                  </div>

                  {/* Image Count */}
                  <div className="image-count">
                    {selectedImages.length} image{selectedImages.length !== 1 ? 's' : ''}
                  </div>

                  {/* BODY */}
                  <div className="modal-body d-flex flex-column align-items-center body-content">
                    <div className="d-flex justify-content-center align-items-center body-content-inner">
                      {/* LEFT ARROW */}
                      {selectedImages.length > 1 && (
                        <button className={`image-carousel-left-btn ${carouselBaseImagesIndex === 0 ? 'inactive' : ''}`}
                          onClick={() => setCarouselBaseImagesIndex((prev) => Math.max(prev - 1, 0))}
                          disabled={carouselBaseImagesIndex === 0}
                        >
                          ‹
                        </button>
                      )}

                      {/* IMAGES */}
                      <div className="image-gallery-carousel">
                          {selectedImages.slice(carouselBaseImagesIndex, carouselBaseImagesIndex + 3).map((url, idx) => (
                            <div className="image-container" key={carouselBaseImagesIndex + idx} >
                              <img className="carousel-image" src={`${publicAssetsUrl}${url}`} alt={`img-${carouselBaseImagesIndex + idx}`}/>
                            </div>
                          ))}
                      </div>

                      {/* RIGHT ARROW */}
                      {selectedImages.length > 1 && (
                        <button
                          className={`image-carousel-right-btn ${carouselBaseImagesIndex >= selectedImages.length - 3 ? 'inactive' : ''}`}
                          onClick={() => setCarouselBaseImagesIndex((prev) => Math.min(prev + 1, selectedImages.length - 3))}
                          disabled={carouselBaseImagesIndex >= selectedImages.length - 3}
                        >
                          ›
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isProductImageModalOpen && viewMode === "edit" && (
            <div className="modal d-block modal-images-gallery-carousel" tabIndex={-1} onClick={() => handleCloseAndResetModal("edit-gallery")}>
              <div className="modal-dialog modal-xl modal-dialog-centered images-gallery-carousel-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content position-relative images-gallery-carousel-inner">
                  {/* HEADER */}
                  <div className="modal-header border-0 pb-2 pt-3 px-4 header-content">
                     <h5 className="modal-title fw-semibold mb-0 header-title">
                      <span className="title">Product</span>
                       { productType === "base_assets" && <span className="product">{selectedVariant?.name}</span>}
                       { productType === "variant_assets" && <span className="product">{selectedVariant?.name}</span>}
                    </h5>
                     <button className="close-gallery-btn" type="button" onClick={() => handleCloseAndResetModal("edit-gallery")}>
                      ✕
                     </button>
                  </div>
                  {/* IMAGE COUNT */}

                  { productType === "base_assets" && <div className="image-count"> {selectedBaseProductImages?.length} image{selectedBaseProductImages?.length !== 1 ? "s" : ""}</div>}
                  { productType === "variant_assets" && <div className="image-count">{selectedVariantImages?.length} image{selectedVariantImages?.length !== 1 ? "s" : ""} </div>}
                  
                  {/* BODY */}
                  <div className="modal-body d-flex flex-column align-items-center body-content">
                    <div className="d-flex justify-content-center align-items-center body-content-inner">
                      {/* LEFT ARROW */}
                       { productType === "base_assets" && 
                        <>
                          {selectedBaseProductImages && selectedBaseProductImages?.length > 1 && (
                            <button className={`image-carousel-left-btn ${carouselIndex === 0 ? 'inactive' : ''}`}
                              onClick={() => setCarouselIndex((prev) => Math.max(prev - 1, 0))}
                              disabled={carouselIndex === 0}
                            >
                              ‹
                            </button>
                          )}

                          {/* IMAGES */}
                          <div className="image-gallery-carousel">
                            {selectedBaseProductImages && selectedBaseProductImages.slice(carouselIndex, carouselIndex + 3).map((asset, idx) => (
                              <div className="image-container" key={asset.id}>
                                <img className="carousel-image" src={`${publicAssetsUrl}${asset.url}`} alt={`img-${carouselIndex + idx}`}/>
                              </div>
                            ))}
                          </div>

                          {/* RIGHT ARROW */}
                          {selectedBaseProductImages && selectedBaseProductImages.length > 1 && (
                            <button
                              className={`image-carousel-right-btn ${carouselIndex >= selectedBaseProductImages.length - 3 ? 'inactive' : ''}`}
                              onClick={() => setCarouselIndex((prev) => Math.min(prev + 1, selectedBaseProductImages.length - 3))}
                              disabled={carouselIndex >= selectedBaseProductImages.length - 3}
                            >
                              ›
                            </button>
                          )}
                        </> 
                       }

                      { productType === "variant_assets" && 
                        <>
                          {selectedVariantImages && selectedVariantImages?.length > 1 && (
                            <button className={`image-carousel-left-btn ${carouselIndex === 0 ? 'inactive' : ''}`}
                              onClick={() => setCarouselIndex((prev) => Math.max(prev - 1, 0))}
                              disabled={carouselIndex === 0}
                            >
                              ‹
                            </button>
                          )}

                          {/* IMAGES */}
                          <div className="image-gallery-carousel">
                            {selectedVariantImages && selectedVariantImages.slice(carouselIndex, carouselIndex + 3).map((asset, idx) => (
                              <div className="image-container" key={asset.id}>
                                <img className="carousel-image" src={`${publicAssetsUrl}${asset.url}`} alt={`img-${carouselIndex + idx}`}/>
                              </div>
                            ))}
                          </div>

                          {/* RIGHT ARROW */}
                          {selectedVariantImages && selectedVariantImages.length > 1 && (
                            <button
                              className={`image-carousel-right-btn ${carouselIndex >= selectedVariantImages.length - 3 ? 'inactive' : ''}`}
                              onClick={() => setCarouselIndex((prev) => Math.min(prev + 1, selectedVariantImages.length - 3))}
                              disabled={carouselIndex >= selectedVariantImages.length - 3}
                            >
                              ›
                            </button>
                          )}
                        </> 
                       }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

            </Container>
        </React.Fragment>
    );
}



//  <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">BASIC PRODUCT DATA</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//   <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>ID</td>
//         <td><input type="text" className="form-control" placeholder="Enter ID" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Name</td>
//         <td><input type="text" className="form-control" placeholder="Enter Name" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Description</td>
//         <td><textarea className="form-control" placeholder="Enter Description" disabled  rows={3}></textarea></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Link URL</td>
//         <td><input type="url" className="form-control" placeholder="Enter Link URL" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Image URL</td>
//         <td><input type="url" className="form-control" placeholder="Enter Image URL" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Additional Image URL</td>
//         <td><input type="url" className="form-control" placeholder="Enter Additional Image URL" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Mobile Link</td>
//         <td><input type="url" className="form-control" placeholder="Enter Mobile Link" disabled  /></td>
//       </tr>
//     </tbody>
//   </table>
//   </div>

//   <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">PRICE & AVAILABILITY</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//     <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>Availability</td>
//         <td><input type="text" className="form-control" placeholder="Enter Availability" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Availability Date</td>
//         <td><input type="text" className="form-control" placeholder="Enter Availability Date" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Cost Of Goods Sold</td>
//         <td><input type="url" className="form-control" placeholder="Enter Cost Of Goods Sold" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Expiration Date</td>
//         <td><input type="url" className="form-control" placeholder="Enter Expiration Date" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Price </td>
//         <td><input type="url" className="form-control" placeholder="Enter Price" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Sale Price</td>
//         <td><input type="url" className="form-control" placeholder="Enter Sale Price" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Sale Price Effective Date</td> 
//         <td><input type="url" className="form-control" placeholder="Enter Sale Price Effective Date" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Unit Pricing Measure</td>
//         <td><input type="url" className="form-control" placeholder="Enter Unit Pricing Measure" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Installment</td> 
//         <td><input type="url" className="form-control" placeholder="Enter Installment" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Subscription Cost </td> 
//         <td><input type="url" className="form-control" placeholder="Enter Subscription Cost" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Loyalty Program </td>
//         <td><input type="url" className="form-control" placeholder="Enter Loyalty Program" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Minimum Price</td>
//         <td><input type="url" className="form-control" placeholder="Enter Minimum Price" disabled  /></td>
//       </tr>
//     </tbody>
//   </table>
//   </div>


//   <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">PRODUCT CATEGORY</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//     <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>Google Product Category </td>
//         <td><input type="text" className="form-control" placeholder="Enter Google Product Category" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Product Type</td>
//         <td><input type="text" className="form-control" placeholder="Enter Product Type" disabled  /></td>
//       </tr>
//     </tbody>
//   </table>
//   </div>


//   <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">PRODUCT IDENTIFIERS</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//     <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>Brand </td>
//         <td><input type="text" className="form-control" placeholder="Enter Brand" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Global Trade Item Number</td>
//         <td><input type="text" className="form-control" placeholder="Enter Global Trade Item Number (GTIN)" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Manufacturer Part Number</td>
//         <td><input type="text" className="form-control" placeholder="Enter Manufacturer Part Number (MPN)" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Identifier Exists</td>
//         <td><input type="text" className="form-control" placeholder="Enter Identifier Exists" disabled  /></td>
//       </tr>
//     </tbody> 
//   </table>
//   </div>


//   <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">DETAILED PRODUCT DESCRIPTION</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//     <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>Condition </td>
//         <td><input type="text" className="form-control" placeholder="Enter Condition" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Adult</td>
//         <td><input type="text" className="form-control" placeholder="Enter Adult" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Multipack</td>
//         <td><input type="text" className="form-control" placeholder="Enter Multipack" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Bundle</td>
//         <td><input type="text" className="form-control" placeholder="Enter Bundle" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Certification</td>
//         <td><input type="text" className="form-control" placeholder="Enter Certification" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Energy Efficiency Class </td>
//         <td><input type="text" className="form-control" placeholder="Enter Energy Efficiency Class" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Minimum Energy Efficiency Class </td>
//         <td><input type="text" className="form-control" placeholder="Enter Minimum Energy Efficiency Class" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Maximum Energy Efficiency Class</td>
//         <td><input type="text" className="form-control" placeholder="Enter Maximum Energy Efficiency Class" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Age Group</td>
//         <td><input type="text" className="form-control" placeholder="Enter Age Group" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Color</td>
//         <td><input type="text" className="form-control" placeholder="Enter Color" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Gender</td>
//         <td><input type="text" className="form-control" placeholder="Enter Gender" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Material</td>
//         <td><input type="text" className="form-control" placeholder="Enter Material" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Pattern</td>
//         <td><input type="text" className="form-control" placeholder="Enter Pattern" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Size</td>
//         <td><input type="text" className="form-control" placeholder="Enter Size" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Size Type</td>
//         <td><input type="text" className="form-control" placeholder="Enter Size Type" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Size System</td>
//         <td><input type="text" className="form-control" placeholder="Enter Size System" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Item Group ID</td>
//         <td><input type="text" className="form-control" placeholder="Enter Item Group ID" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Product Length</td>
//         <td><input type="text" className="form-control" placeholder="Enter Product Length" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Product Width</td>
//         <td><input type="text" className="form-control" placeholder="Enter Product Width" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Product Height</td>
//         <td><input type="text" className="form-control" placeholder="Enter Product Height" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Product Weight</td>
//         <td><input type="text" className="form-control" placeholder="Enter Product Weight" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Product Detail</td>
//         <td><input type="text" className="form-control" placeholder="Enter Product Detail" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Product Highlight</td>
//         <td><input type="text" className="form-control" placeholder="Enter Product Highlight" disabled  /></td>
//       </tr>
//     </tbody> 
//     </table>
//   </div>


//   <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">DESTINATIONS</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//     <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>Excluded Destination</td>
//         <td><input type="text" className="form-control" placeholder="Enter Excluded Destination" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Included Destination</td>
//         <td><input type="text" className="form-control" placeholder="Enter Included Destination" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Excluded Countries For Shopping Ads</td>
//         <td><input type="text" className="form-control" placeholder="Enter Excluded Countries For Shopping Ads" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Pause</td>
//         <td><input type="text" className="form-control" placeholder="Enter Pause" disabled /></td>
//       </tr>
//     </tbody> 
//   </table>
//   </div>


//   <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">SHIPPING</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//     <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>Shipping</td>
//         <td><input type="text" className="form-control" placeholder="Enter Shipping" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Shipping Label</td> 
//         <td><input type="text" className="form-control" placeholder="Enter Shipping Label" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Shipping Weight</td>
//         <td><input type="text" className="form-control" placeholder="Enter Shipping Weight" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Shipping Length</td>
//         <td><input type="text" className="form-control" placeholder="Enter Shipping Length" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Shipping Width</td>
//         <td><input type="text" className="form-control" placeholder="Enter Shipping Width" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Shipping Height</td> 
//         <td><input type="text" className="form-control" placeholder="Enter Shipping Height" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Ships From Country</td>
//         <td><input type="text" className="form-control" placeholder="Enter Ships From Country" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Maximum Handling Time </td> 
//         <td><input type="text" className="form-control" placeholder="Enter Maximum Handling Time " disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Shipping Label </td> 
//         <td><input type="text" className="form-control" placeholder="Enter Shipping Label " disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Minimum Handling Time</td> 
//         <td><input type="text" className="form-control" placeholder="Enter Minimum Handling Time" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Free Shipping Threshold</td> 
//         <td><input type="text" className="form-control" placeholder="Enter Free Shipping Threshold" disabled /></td>
//       </tr>
//     </tbody> 
//   </table>
//   </div>

  
//     <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">TAX</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//     <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>Tax</td>
//         <td><input type="text" className="form-control" placeholder="Enter Tax" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Tax Category</td>
//         <td><input type="text" className="form-control" placeholder="Enter Tax Category" disabled  /></td>
//       </tr>
//     </tbody> 
//   </table>
//   </div>